module.exports = __webpack_public_path__ + "static/media/USTaxl.cc9a4a6c.png";